import styled from 'styled-components';

import InputMask from 'react-input-mask';

export const Input01 = styled.input`
  width: 100%;
  float: left;
  font-size: 1.2rem;
  border: none;
  height: 4rem;
  line-height: 4rem;
  background: none;
  font-weight: 500;
  padding: 0 1rem;
  border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
  border-radius: 0.6rem;
  color: ${({ theme }) => theme.colors.TEXT1};

  ::-webkit-input-placeholder {
    background: ${({ theme }) => theme.colors.TEXT1};
  }

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  @media (max-width: 1024px) {
    font-size: 1rem;
  }
`;

export const Input02 = styled(InputMask)`
  width: 100%;
  float: left;
  font-size: 1.2rem;
  border: none;
  height: 4rem;
  line-height: 4rem;
  background: none;
  font-weight: 500;
  padding: 0 1rem;
  border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
  border-radius: 0.6rem;
  color: ${({ theme }) => theme.colors.TEXT1};

  ::-webkit-input-placeholder {
    color: ${({ theme }) => theme.colors.TEXT1};
  }

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  @media (max-width: 1024px) {
    font-size: 1rem;
  }
`;
